"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const CameraViewRenderer = ({ control, style, }) => {
    const { Render, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    (0, useOnLoad_1.default)(control, events);
    const handleTakePicture = (0, react_1.useCallback)((uri) => {
        if (events.onTakePicture) {
            events.onTakePicture(uri);
        }
        if (processor) {
            processor.root.updateControlById({
                control,
                dataToUpdate: {
                    takePhoto: undefined,
                },
            });
        }
    }, [control, events, processor]);
    const cameraViewStyles = (0, react_1.useMemo)(() => ({
        width: style.width,
        height: style.height,
    }), [style]);
    const handleStartRecord = (0, react_1.useCallback)((uri) => {
        if (events.onStartRecord) {
            events.onStartRecord(uri);
        }
        if (processor) {
            processor.root.updateControlById({
                control,
                dataToUpdate: {
                    startRecord: undefined,
                },
            });
        }
    }, [control, events, processor]);
    const handleStopRecord = (0, react_1.useCallback)(() => {
        if (events.onStopRecord) {
            events.onStopRecord();
        }
        if (processor) {
            processor.root.updateControlById({
                control,
                dataToUpdate: {
                    stopRecord: undefined,
                },
            });
        }
    }, [control, events, processor]);
    const onQRCodeRead = (0, react_1.useCallback)(() => {
        if (!events.onQRCodeRead && !events.onBarCodeRead) {
            return undefined;
        }
        return (event) => {
            const isQR = event.type === 'QR_CODE' || event.type === 'qr';
            if (events.onQRCodeRead && isQR) {
                events.onQRCodeRead(event);
            }
            if (events.onBarCodeRead && !isQR) {
                events.onBarCodeRead(event);
            }
        };
    }, [events]);
    return (react_1.default.createElement(Render.CameraView, { type: control.type, style: cameraViewStyles, takePhoto: control.takePhoto, startRecord: control.startRecord, stopRecord: control.stopRecord, onTakePicture: handleTakePicture, onStartRecord: handleStartRecord, onStopRecord: handleStopRecord, onQRBarcodeRead: onQRCodeRead() }));
};
exports.default = CameraViewRenderer;
